import { useTranslation } from 'react-i18next';
import { ContractModel } from 'api/contracts/enums/ContractModel';
import styles from '../BulkContractsScreen.module.scss';

type Props = {
    onSelect: (model: ContractModel) => void;
};

// Task #66347: primeiro passo — que tipo de contratos vai o utilizador inserir/atualizar. As cores
// são as mesmas dos badges da listagem de contratos, para se reconhecer a família de imediato.
const FAMILIES: { model: ContractModel; color: string; labelKey: string; descriptionKey: string }[] = [
    { model: ContractModel.USE, color: '#026a8f', labelKey: 'contracts_listing.type_use', descriptionKey: 'bulk_contracts.families.use_description' },
    { model: ContractModel.MAINTENANCE, color: '#038cb6', labelKey: 'contracts_listing.type_maintenance', descriptionKey: 'bulk_contracts.families.maintenance_description' },
    { model: ContractModel.INSURANCE, color: '#02c7c7', labelKey: 'contracts_listing.type_insurance', descriptionKey: 'bulk_contracts.families.insurance_description' },
];

const ContractFamilyStep = ({ onSelect }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={styles.familyStep}>
            <h3 className={styles.familyTitle}>{t('bulk_contracts.family_step_title')}</h3>
            <p className={styles.familyHint}>{t('bulk_contracts.family_step_hint')}</p>

            <div className={styles.familyCards}>
                {FAMILIES.map(family => (
                    <button
                        key={family.model}
                        type="button"
                        className={styles.familyCard}
                        onClick={() => onSelect(family.model)}
                    >
                        <span className={styles.familyBadge} style={{ backgroundColor: family.color }} />
                        <span className={styles.familyCardTitle}>{t(family.labelKey as any)}</span>
                        <span className={styles.familyCardDescription}>{t(family.descriptionKey as any)}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ContractFamilyStep;
